import './FeedbackForm.scss';
import React, { useState, useEffect } from 'react';
import Popup from '../Popup/Popup';
import IconButton from '../IconButton/IconButton';

// Image assets
import IconCheckmark from '../../assets/icons/icon-checkmark.svg';
import IconAttention from '../../assets/icons/icon-attention.svg';


import { ClipLoader } from 'react-spinners';
import PopupSuccess from '../PopupSuccess/PopupSuccess';


const FeedbackForm = () => {

  const [showPopup, setShowPopup] = useState(false);
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [comment, setComment] = useState('');
  const [likeStatus, setLikeStatus] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [postId, setPostId] = useState(null);
  const [charCount, setCharCount] = useState(0);
  
  useEffect(() => {
    fetch('/wp-json/wp/v2/posts?_embed')
      .then(response => response.json())
      .then(posts => {
        const currentPost = posts.find(post => 
          window.location.pathname.includes(post.slug) 
        );
        setPostId(currentPost ? currentPost.id : null);
      })
      .catch(error => console.error('Failed to fetch post data:', error));
  }, [window.location.pathname]);

  useEffect(() => {
    setCharCount(comment.length);
  }, [comment]);
  
  const remainingChars = 500 - charCount;

  const handleFeedbackClick = (status) => {
    setLikeStatus(status);
    setSelectedOption(null);
    setShowPopup(true);
  };

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  const handleGoBack = () => {
    setSelectedOption(null);
    setComment('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    setIsLoading(true); 
    const feedback = { postId: postId, likeStatus, selectedOption, comment };
  
    fetch('/wp-json/feedback/v1/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': wpApiSettings.nonce
      },
      body: JSON.stringify(feedback)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
    
      setComment('');
      setSelectedOption(null); 
      setLikeStatus(null);    
  
      setIsLoading(false);    
      setShowPopup(false);     
      setShowThankYouPopup(true);  
    })
    .catch((error) => {
      console.error('Error:', error);
      setIsLoading(false);
    });
  };
  


  const renderOptions = () => {
    const options = likeStatus === 'like'
      ? [
          'The article provided the information I was looking for.',
          'The writing style was engaging and interesting.',
          'The article was well-structured and easy to follow.',
          'Other'
        ]
      : [
          'The article did not provide the information I was looking for.',
          'The article contains too many difficult jargons.',
          'The article lacks depth/detail on the topic.',
          'Other'
        ];

    const Icon = likeStatus === 'like' ? IconCheckmark : IconAttention;
    const iconClass = likeStatus === 'like' ? 'label__icon--like' : 'label__icon--dislike';

    return options.map(option => (
      <div key={option} className="option-item">
        <input
          type="radio"
          id={`${option}Option`}
          name="feedbackOption"
          value={option}
          checked={selectedOption === option}
          onChange={() => handleOptionChange(option)}
        />
        <label htmlFor={`${option}Option`}>
          <img src={Icon} className={`label__icon ${iconClass}`} alt="" />
          <div>{option}</div>
        </label>
      </div>
    ));
  };


  const renderFeedbackForm = () => {
    const SelectedIcon = likeStatus === 'like' ? IconCheckmark : IconAttention;
    const iconClass = likeStatus === 'like' ? 'label__icon--like' : 'label__icon--dislike';
    const commentCharacterClass = remainingChars > 0 ? 'green' : 'red';
  
    return selectedOption ? (
      <>
        <div key={selectedOption} className="selected-option-item">
          <label className="selected" htmlFor={`${selectedOption}Option`}>
            <img src={SelectedIcon} alt={selectedOption} className={`label__icon ${iconClass}`}/>
            <div>{selectedOption}</div>
          </label>
        </div>
        <div className="feedback-form__change-option">
          <button
            className="feedback-form__back-button"
            type="button"
            onClick={handleGoBack}
            disabled={isLoading}
          >
            Change
          </button>
        </div>
        <p className="feedback-form__text-lenght">
          <span className={`text-color__${commentCharacterClass}`}>
            {remainingChars}
          </span>{' '}
          / 500
        </p>
        <textarea
          id="comment"
          className="feedback-form__comment"
          value={comment}
          placeholder="Please share your opinion with us"
          onChange={(e) => setComment(e.target.value)}
          maxLength="500"
          disabled={isLoading}
        />
        <p className="feedback-form__disclaimer">
          We take your privacy seriously. Please note that any feedback you provide on our articles
          may be stored on servers and used exclusively for analytical purposes to improve our
          content. If you disagree with this policy, we advise against sharing your feedback.
        </p>
        <div>
          <button className="feedback-form__submit-btn" type="submit">
            {isLoading ? <ClipLoader size={28} color={'#ffffff'} /> : 'SEND'}
          </button>
        </div>
      </>
    ) : (
      <>
        {renderOptions()}
      </>
    );
  };
  
  const popupHeadline = likeStatus === 'like' ? "Share your thoughts on this article:" : "How can we improve it?";

  return (
    <div className="feedback-form__wrapper">
      <div>
        <h5 className="feedback-form__headline">Was this article helpful?</h5>
      </div>
      <div className="feedback-form__cta">
        <IconButton iconName="like" onClick={() => handleFeedbackClick('like')} />
        <IconButton iconName="dislike" onClick={() => handleFeedbackClick('dislike')} />
      </div>
      <Popup isOpen={showPopup} onClose={() => setShowPopup(false)} status={likeStatus}>
        <form onSubmit={handleSubmit} className='feedback-form'>
          <h5 className="feedback-form__headline feedback-form__headline--inner">{popupHeadline}</h5>
          { renderFeedbackForm() }
        </form>
      </Popup>
      {showThankYouPopup && (
        <Popup isOpen={showThankYouPopup} onClose={() => setShowThankYouPopup(false)}>
          <PopupSuccess onClose={() => setShowThankYouPopup(false)}/>
        </Popup>
      )}
    </div>
  );
    
}

export default FeedbackForm;